export default "__VITE_ASSET__2cbcabfc__"